// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Mirrors the global \`img { max-width: 100%; height: auto; display: block; }\` rule from
 * GlobalStyles.ts so a sprite <svg> occupies the same box the <img> it replaces did.
 * Site-specific \`img\` rules that size icons have \`svg\` twins next to them.
 */
.iNLNF5QzDK4BJFPOElWw {
  display: block;
  max-width: 100%;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/SvgSprite/SpriteSvg.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd","sourcesContent":["/*\n * Mirrors the global `img { max-width: 100%; height: auto; display: block; }` rule from\n * GlobalStyles.ts so a sprite <svg> occupies the same box the <img> it replaces did.\n * Site-specific `img` rules that size icons have `svg` twins next to them.\n */\n.sprite {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sprite": `iNLNF5QzDK4BJFPOElWw`
};
export default ___CSS_LOADER_EXPORT___;
